// Configuration for the quotes application
const config = {
  quotesUrl: 'https://raw.githubusercontent.com/pappater/niche/9cfe6bd0691cfd2fe109f6a1cf597e5cf11102cf/public/quotes.json'
};

export default config;
